import type { Dispatch } from '@reduxjs/toolkit';
import { config } from '../../config';
import { CommHandler } from '../../utils';
import { setIsSuperadmin } from './roleSlice';
import { Role } from './roleTypes';
import checkSuperadminStatus from '../../utils/checkSuperAdmin';

const fetchRoles = async (dispatch: Dispatch): Promise<Role[]> => {
  const email = localStorage.getItem('email');

  if (!email) {
    return Promise.reject(new Error('Email not found'));
  }

  try {
    const response = await CommHandler.request({
      url: `${config.rbacApiBaseUrl}/role/user-role`,
      method: 'GET',
    });

    const roles = response.data;
    const isUserSuperadmin = await checkSuperadminStatus(email);

    dispatch(setIsSuperadmin(isUserSuperadmin));
    return roles;
  } catch (error) {
    console.error('Error fetching roles:', error);
    return Promise.reject(new Error('Error fetching roles'));
  }
};

export default fetchRoles;
